
class PersonalizeProduct extends HTMLElement {
  constructor() {
    super();
    this.textFront = new Map();
    this.timeoutId = null;
    this.inputTextValue = '';

    this.canvaFontSizeSmall = this.dataset.canvaFontSizePequena;
    this.canvaFontSizeBig = this.dataset.canvaFontSizeGrande;
    this.canvaFontColor = this.dataset.canvaFontColor;

    this.summaryCustomization = this.querySelector('summary');
    this.buyButton = document.querySelector("form[action$='/cart/add'] button[type='submit']");
    this.mensagemErro = document.querySelector(".personalize__message-prohibited-words");
    this.productForm = document.querySelector(`#product-form-${this.dataset.section}`);
    this.palavrasProibidas = window.palavrasProibidas.sort((a, b) => a.localeCompare(b)) || [];
    this.inputTexto = this.querySelector(`[id^="Personalize-name"]`);
    this.checkboxSemPersonalizacao = this.querySelector(".no-customization");
    this.buttonOpenPersonalize = this.querySelector('.details-container-button');
    this.loading = this.querySelector('.personalize__loading');
    this.contentForm = this.querySelector('.personalize__form');
    this.allCheckboxInputs = this.querySelectorAll('.product-form__input');
    this.charactersUsed = this.querySelector('.characters_used');
    this.productPrice = Number(this.dataset.productPrice);
    this.productHasDiscount = this.dataset.productHasDiscount;
    this.isNotEmpty = false;
    this.freeCustomization = this.dataset.freeCustomization === 'true';

    this.fontFamily = this.querySelector('.personalize-font input').value;
    this.fontSize = this.querySelector('.personalize-size input').value;

    this.inputTexto.addEventListener('keyup', () => this.onTextChange());

    this.querySelectorAll('.personalize-font label').forEach(label => {
      label.addEventListener('click', (event) => this.onFontChange(event));
    });

    this.querySelectorAll('.personalize-size label').forEach(label => {
      label.addEventListener('click', (event) => this.onSizeChange(event));
    });

    this.checkboxSemPersonalizacao.addEventListener('change', () => {
      if (this.checkboxSemPersonalizacao.checked) {
        this.disablePersonalization();
        this.removeDefaultCustomization();
        this.alterarEstadoBotao(true);
        this.removeCanvas();
      } else {
        this.enablePersonalization();
        this.alterarEstadoBotao(this.inputTexto.value.trim().length > 0);
        this.createCanvas();
      }
    });

    this.summaryCustomization.addEventListener('click', () => {
      if (this.summaryCustomization.closest('details').hasAttribute('open') || this.checkboxSemPersonalizacao.checked) {
        this.disablePersonalization();
        this.removeDefaultCustomization();
        this.alterarEstadoBotao(true);
        this.removeCanvas();
      } else {
        this.enablePersonalization();
        this.alterarEstadoBotao(false);
        this.createCanvas();
      }
    });

    this.loading.classList.add('hidden');
    this.contentForm.classList.remove('hidden');

    window.addEventListener('resize', () => {
      this.drawCanvasContent();
    });
  }

  onTextChange() {
    this.inputTextValue = this.inputTexto.value.trim();
    this.updateInputHidden('Texto da personalização', this.inputTextValue);
    this.textFront.set(this.inputTexto.dataset.id, this.inputTextValue);
    this.charactersUsed.innerText = this.inputTextValue.length;

    this.verificarPalavrasProibidas(this.inputTextValue);

    if (this.inputTextValue && !this.isNotEmpty) {
      this.addDefaultCustomization();
      this.isNotEmpty = true;
      this.createCanvas();
    } else if (!this.inputTextValue && this.isNotEmpty) {
      this.removeDefaultCustomization();
      this.isNotEmpty = false;
      this.alterarEstadoBotao(false);
    }

    this.drawCanvasContent();
  }

  verificarPalavrasProibidas(texto) {
    const textoLimpo = texto.toLowerCase().trim();
    if (!textoLimpo) this.mensagemErro.classList.add('hidden');

    const palavras = textoLimpo.split(/\s+/);

    const palavraEncontrada = this.palavrasProibidas.find(palavra =>
      palavras.includes(palavra.toLowerCase())
    );

    clearTimeout(this.timeoutId);

    if (palavraEncontrada) {
      this.alterarEstadoBotao(false);
    } else {
      this.alterarEstadoBotao(texto.length > 0);
      this.mensagemErro.classList.add('hidden');
    }
  
    this.timeoutId = setTimeout(() => {
      if (palavraEncontrada) {
        this.mensagemErro.textContent = `O texto informado contém palavras que não são permitidas.`;
        this.mensagemErro.classList.remove('hidden');
      }
    }, 400);
  }

  enablePersonalization() {
    this.inputTexto.disabled = false;

    this.allCheckboxInputs.forEach((fieldset) => {
      fieldset.style.opacity = '1';
      fieldset.querySelectorAll('input').forEach((input) => input.disabled = false);
      fieldset.querySelectorAll('label').forEach((label) => label.style.pointerEvents = 'auto');
    });

    this.charactersUsed.innerText = this.inputTexto.value.length;

    this.onTextChange();
  }

  addDefaultCustomization() {
    this.initCustomization('Fonte do texto personalizado', 'personalize-font');
    this.initCustomization('Tamanho do texto personalizado', 'personalize-size');
    this.initCustomization('Orientação do texto personalizado', 'personalize-position');
    this.updateInputHidden('_diasAdicionaisFrete', 5);

    if (this.freeCustomization) {
      if (this.productHasDiscount === 'true') {
        this.updateCustomPrice(this.productPrice * 0.5);
      } else {
        this.updateCustomPrice(this.productPrice);
      }
    } else {
      if (this.productHasDiscount === 'true') {
        this.updateCustomPrice((this.productPrice * 0.5) + 20);
      } else {
        this.updateCustomPrice(this.productPrice + 20);
      }
    }
  }

  disablePersonalization() {
    this.inputTexto.disabled = true;
    this.inputTexto.value = "";

    this.allCheckboxInputs.forEach((fieldset) => {
      fieldset.style.opacity = '0.5';
      fieldset.querySelectorAll('input').forEach((input) => input.disabled = true);
      fieldset.querySelectorAll('label').forEach((label) => label.style.pointerEvents = 'none');
    });

    this.charactersUsed.innerText = "0";
  }

  removeDefaultCustomization() {
    this.removeInputHidden('Fonte do texto personalizado');
    this.removeInputHidden('Tamanho do texto personalizado');
    this.removeInputHidden('Orientação do texto personalizado');
    this.removeInputHidden('Texto da personalização');
    this.removeInputHidden('_diasAdicionaisFrete');

    if (this.productHasDiscount === 'true') {
      this.updateCustomPrice(this.productPrice * 0.5);
    } else {
      this.updateCustomPrice(this.productPrice);
    }
  }

  alterarEstadoBotao(ativo) {
    this.buyButton.disabled = !ativo;
    this.buyButton.style.opacity = ativo ? "1" : "0.5";
  }

  initCustomization(properties, specialClass) {
    this.updateInputHidden(properties, this.querySelector(`.${specialClass} input:checked`).value);
  }

  updateCustomPrice(valor) {
    let inputLojinha =  this.productForm.querySelector(`input[name="properties[_lojinha]"]`);
    if ( inputLojinha && inputLojinha.value == 'true') {
      let inputAdditionalPrice = this.productForm.querySelector(`input[name="properties[_additional_price]"]`);
      if (!inputAdditionalPrice) {
        inputAdditionalPrice = document.createElement('input');
        inputAdditionalPrice.type = 'hidden';
        inputAdditionalPrice.name = `properties[_additional_price]`;
        this.productForm.appendChild(inputAdditionalPrice);
      }
      inputAdditionalPrice.value = '20';
    } else {
      let input = this.productForm.querySelector(`input[name="properties[_custom_price]"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[_custom_price]`;
        this.productForm.appendChild(input);
      }
      input.value = valor;

    //   let inputAdditionalPrice = this.productForm.querySelector(`input[name="properties[_additional_price]"]`);

    //   if (!inputAdditionalPrice) {
    //     inputAdditionalPrice = document.createElement('input');
    //     inputAdditionalPrice.type = 'hidden';
    //     inputAdditionalPrice.name = `properties[_additional_price]`;
    //     this.productForm.appendChild(inputAdditionalPrice);
    //   }
    //   inputAdditionalPrice.value = '20';
    }
  }

  updateInputHidden(nome, valor) {
    let input = this.productForm.querySelector(`input[name="properties[${nome}]"]`);
    if (!input && this.inputTexto.value.trim().length > 0) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${nome}]`;
      this.productForm.appendChild(input);
    }

    if (this.inputTexto.value.trim().length > 0) input.value = valor;
  }

  removeInputHidden(nome) {
    const input = this.productForm.querySelector(`input[name="properties[${nome}]"]`);
    if (input) input.remove();
  }

  onFontChange(event) {
    const fontFamily = event.target.closest('.item').querySelector('input').value;
    this.inputTexto.style.fontFamily = fontFamily;
    this.updateInputHidden('Fonte do texto personalizado', fontFamily);
    this.fontFamily = fontFamily;
    this.drawCanvasContent();
  }

  onSizeChange(event) {
    const fontSize = event.target.closest('.item').querySelector('input').value;
    this.updateInputHidden('Tamanho do texto personalizado', fontSize);
    this.fontSize = fontSize;
    this.drawCanvasContent();
  }

  removeCanvas() {
    const canvas = document.querySelector('#PreviewPersonalize');
    if (canvas) canvas.remove();
  }

  createCanvas() {
    const canvasImage = document.querySelector('.personalized-product');
    const existCanvas = document.querySelector('#PreviewPersonalize');

    if(!existCanvas) {
      var newCanvas = document.createElement('canvas');
      newCanvas.setAttribute('id', 'PreviewPersonalize');
      canvasImage.appendChild(newCanvas);
      this.initialWidth = canvasImage.clientWidth;
      this.initialHeight = canvasImage.clientHeight;
    }

    this.drawCanvasContent();
  }

  drawCanvasContent() {
    const canvasImage = document.querySelector('.personalized-product');
    const canvas = document.getElementById('PreviewPersonalize');
    const fieldsData = JSON.parse(document.querySelector('#PersonalizeJSON').textContent);

    if (!(canvas && fieldsData.axis_x && fieldsData.axis_y )) return;
    canvas.setAttribute('width', canvasImage.clientWidth);
    canvas.setAttribute('height', canvasImage.clientHeight);

    const initialFontSize = this.fontSize == 'Pequeno' ? this.canvaFontSizeSmall : this.canvaFontSizeBig;
    let fontSize = initialFontSize;

    if (canvasImage.clientWidth !== this.initialWidth) {
      fontSize = (canvasImage.clientWidth * initialFontSize) / this.initialWidth;
    }
    const ctx = canvas.getContext('2d');

    let scaleAdjust = 1;
    if (this.fontFamily === "Dancing Script" || this.fontFamily === "DM Serif Text" || this.fontFamily === "Patua One") {
      scaleAdjust = 1.1;
    }

    ctx.font = `${fontSize * scaleAdjust}px ${this.fontFamily}`;

    ctx.fillStyle = this.canvaFontColor;
    ctx.textAlign = 'center';

    const initialX = (fieldsData.axis_x * this.initialWidth) / 500;
    const initialY = (fieldsData.axis_y * this.initialHeight) / 500;

    const x = (canvasImage.clientWidth * initialX) / this.initialWidth;
    const y = (canvasImage.clientHeight * initialY) / this.initialHeight;
    const text = this.inputTextValue;

    if (text) {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(-Math.PI / 2);
      ctx.fillText(text, 0, 0);
      ctx.restore();
    }
  }
}

customElements.define('personalize-product', PersonalizeProduct);